module.exports = __webpack_public_path__ + "static/media/FeatureDefaultImage.57f6b0ef.jpeg";